import { SanGuoYanYi } from '../../components/san-guo-yan-yi/Home';

export default SanGuoYanYi;
